import script from "./PostReactionDetailPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./PostReactionDetailPopup.vue?vue&type=script&setup=true&lang=ts"

import "./PostReactionDetailPopup.vue?vue&type=style&index=0&id=111e73ea&lang=scss"

const __exports__ = script;

export default __exports__